import { create } from "sheetly";
export let text = ":host>div{display:inline-block;width:1em;height:1em;cursor:pointer}svg{fill:var(--bs-body-color)}";
export const sheet = create(text, import.meta.url);
